<template>
    <div class="atmo-content-group">
        <h5>
            <slot></slot>
        </h5>

        <div class="table-responsive">
            <table class="b-table table">
                <thead>
                    <tr>
                        <th style="width: 20px; max-width: 20px">№</th>
                        <th style="width: 200px; max-width: 200px">Дата и время направления документов</th>
                        <th>Документ</th>
                        <th v-if="!pivc.isPurchaseOutATMO" width="50">Подпись заказчика</th>
                        <th v-if="!pivc.isPurchaseOutATMO" width="50">Подпись поставщика</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(attachment, index) in this.$props.attachments" v-bind:key="index">
                        <td v-text="index + 1"></td>
                        <td>{{ attachment.created_at | formatdate('withSeconds') }}</td>
                        <td style="min-width: 300px">
                            <template v-if="attachment.is_archived">(Архив)&nbsp;</template>
                            <a :href="$getAttachmentDownloadLink(attachment.file_id)" class="atmo-button-link" style="color: var(--green-color) !important" target="_blank">{{ attachment.name }}</a>
                            <template v-if="!pivc.isPurchaseOutATMO">
                                <div v-if="(!$props.pivc.isContractSignedBySupplier || !$props.pivc.isContractSignedByCustomer) && !attachment.is_archived && !$props.pivc.isContractDisputed">
                                    Ожидает подписи
                                    <span v-if="!$props.pivc.isContractSignedBySupplier">поставщика, </span>
                                    <span v-if="!$props.pivc.isContractSignedByCustomer">заказчика</span>
                                </div>
                                <div v-if="!attachment.is_archived && $props.pivc.isContractDisputed">
                                    <span v-text="$props.pivc.purchaseitem.contract.acceptance_status_title"></span>
                                </div>
                            </template>
                        </td>
                        <td v-if="!pivc.isPurchaseOutATMO" class="text-center">
                            <template v-if="$props.pivc.isContractSignedByBoth && !attachment.is_archived">
                                <action-button-small icon="clipboard-check" title="Информация о подписи" @click="$props.pivc.invokeSignaturePopup([$props.signatures.customer])" />
                                <action-button-small v-if="$props.signatures.customer.poa_number && $props.signatures.customer.poa_check_link" class="ml-1" icon="clipboard-plus" title="Информация о МЧД" variant="warning" @click="$props.pivc.invokeSignaturePopup([$props.signatures.customer])" />
                            </template>
                        </td>
                        <td v-if="!pivc.isPurchaseOutATMO" class="text-center">
                            <template v-if="$props.pivc.isContractSignedByBoth && !attachment.is_archived">
                                <action-button-small icon="clipboard-check" title="Информация о подписи" @click="$props.pivc.invokeSignaturePopup([$props.signatures.supplier])" />
                                <action-button-small v-if="$props.signatures.supplier.poa_number && $props.signatures.supplier.poa_check_link" class="ml-1" icon="clipboard-plus" title="Информация о МЧД" variant="warning" @click="$props.pivc.invokeSignaturePopup([$props.signatures.supplier])" />
                            </template>
                        </td>
                    </tr>
                    <tr v-if="$props.attachments < 1">
                        <td class="atmo-centered" colspan="5">Нет документов</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <template v-if="pivc.hasContract && pivc.isUserEngagedCustomer && !pivc.isContractSignedByCustomer && pivc.isContractSignedBySupplier &&  pivc.mustCustomerSignContract">
            <ul class="atmo-content-block-2-columns atmo-no-item-separator">
                <li>
                    <dt class="atmo-help">
                        Номер контракта в системе учета заказчика:
                        <i class="atmo-icon-question-mark"></i>
                        <span class="atmo-help__text">Укажите номер контракта в случае если он отличается от номера контракта в ИС</span>
                    </dt>
                    <dd class="atmo-form__field atmo-inverse">
                        <input v-model="pivc.$data.customer_contract_number" type="text" />
                    </dd>
                </li>
            </ul>
        </template>

        <slot name="controls"></slot>
    </div>
</template>

<script>
export default {
    props: {
        pivc: { required: true, type: Object },
        signatures: { required: true, type: Object },
        attachments: { required: true, type: Array }
    }
};
</script>
